module.exports = __webpack_public_path__ + "img/insuflavelGrandeRosa.9ece7a72.svg";